import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { styled } from "@mui/system";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Header from "../../../Header/Header";
// import QRImg from './img/qr-header.png';
import QRImg from "./img/qr-img.png";
import QRGeneratorSection from "./QRGeneratorSection";
import QRCodeGenerator from "./QRCodeGenerator";
import CustomerSection from "./CustomerSection";
// import CustomerSection1 from './CustomerSection1';
import Faq from "./Faq";
import FooterSection from "../FooterSection";
import { ExpandMore } from "@mui/icons-material";
import Benefits from "./Benefits";
import GetStartedSection from "./Bottom";

const GreenChip = styled(Box)(({ theme }) => ({
  backgroundColor: "#d3f8df",
  color: "#137333",
  fontWeight: "600",
  padding: "8px 16px",
  borderRadius: "24px",
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "16px",
  border: "1px solid #137333",
  cursor: "pointer",
  transition: "background-color 0.3s ease, transform 0.2s ease",

  "&:hover": {
    backgroundColor: "#b9f2cc",
    transform: "scale(1.02)",
  },
}));

const WhatsAppLink = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      <Header />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url('bg2.svg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
            padding: isMobile ? "2rem 1rem" : "4rem 8rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            {/* Left Content Section */}
            <Grid item xs={12} md={6}>
              <GreenChip>
                WhatsApp QR Code Generator <WhatsAppIcon fontSize="small" />
              </GreenChip>

              <Typography
                variant={isMobile ? "h5" : "h3"}
                fontWeight="bold"
                mt={4}
                color="#2f3c4c"
              >
                Generate your <span style={{ color: "#00D084" }}>WhatsApp</span>{" "}
                QR Code for FREE today!
              </Typography>

              <Box display={{xs: 'block', md: 'none'}} pt={4}>
                <img
                  src={QRImg}
                  alt="QR Code Generator"
                  style={{
                    display: { xs: "block", md: "none" },
                    width: "100%",
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </Box>

              <Typography
                variant="body1"
                mt={3}
                mb={4}
                maxWidth="600px"
                color="#4b5563"
                fontSize="18px"
              >
                Make engagement problems a thing of the past with a WhatsApp QR
                Code Generator. Let your customers (current and potential) reach
                you effortlessly, capturing every possible opportunity.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "rgb(4, 77, 145)",
                  fontWeight: "bold",
                  padding: "10px 24px",
                  borderRadius: "8px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgb(40, 106, 168)",
                  },
                }}
              >
                Create QR Code
              </Button>
            </Grid>

            {/* Right Image Section */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{ pl: isMobile ? 0 : 6 }}
              display={{ xs: "none", md: "block" }}
            >
              <img
                src={QRImg}
                alt="QR Code Generator"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  marginLeft: isMobile ? "0" : "24px", // subtle shift
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      <QRGeneratorSection />
      <QRCodeGenerator />
      <CustomerSection />
      <Benefits/>
      <Faq />
      <GetStartedSection/>
      <FooterSection />
    </>
  );
};

export default WhatsAppLink;
